<template>
  <div class="publicProfile">
    <img :src="profile.avatar" class="publicProfile__avatar" alt="avatar"/>

    <p class="publicProfile__name">{{ profile.firstName }} {{ profile.lastName }}</p>

    <div class="publicProfile__info">
<!--      <span class="publicProfile__location">-->
<!--        <gl-svg-icon-->
<!--          class="publicProfile__location__icon icon"-->
<!--          icon="location"-->
<!--        /> Germany, Autsburg-->
<!--      </span>-->
      <span v-if="profile.position" class="publicProfile__position">
        <gl-svg-icon class="publicProfile__location__icon icon" icon="human" />
        {{ profile.position }}
      </span>
    </div>

    <profile-social-links :links="socialLinks"> </profile-social-links>

    <p class="publicProfile__description">
      {{
        $t(
          "PLC Ultima is a massive infrastructure project, which combines the innovation of the blockchain technology with the stability of dozens of time-tested business models."
        )
      }}
    </p>

    <a :href="toRegistration" target="_blank" class="publicProfile__btn">
      {{ $t("Sign up") }}
    </a>
  </div>
</template>

<script>
import GlSvgIcon from "@gl/GlSvgIcon";
import ProfileSocialLinks from "@/components/Landing/components/ProfileSocialLinks";
import store from "@/store";
import { toRegistration } from "@/tools";

export default {
  components: { GlSvgIcon, ProfileSocialLinks },
  name: "PublicProfile",
  computed: {
    toRegistration,
    profile() {
      return store.getters.getProfile
    },
    socialLinks() {
      return [
        {
          name: "phone",
          title: "Phone number",
          url: this.profile.mobile ? `tel:${this.profile.mobile}` : null,
        },
        {
          name: "whatsapp",
          title: "WhatsApp",
          // whatsapp://send?phone=[number] (without '+')
          // https://wa.me/[number] (without '+')
          url: this.profile.whatsapp ? `whatsapp://send?phone=${this.getNumberWithoutPlus(this.profile.whatsapp)}` : null,
        },
        {
          name: "telegram",
          title: "Telegram",
          // tg://resolve?domain=[username]
          url: this.profile.telegram ? `tg://resolve?domain=${this.profile.telegram}` : null,
        },
        {
          name: "instagram",
          title: "Instagram",
          // https://www.instagram.com/[username]
          url: this.profile.instagram ? `https://www.instagram.com/${this.profile.instagram}` : null,
        },
        {
          name: "skype",
          title: "Skype",
          // skype:[nickname]?chat
          url: this.profile.skype ? `skype:${this.profile.skype}?chat` : null,
        },
        {
          name: "viber",
          title: "Viber",
          //viber://chat?number=[number]
          url: this.profile.viber ? `viber://chat?number=${this.getNumberForViberDesktop(this.profile.viber)}` : null,
        },
        {
          name: "wechat",
          title: "WeChat",
          //weixin://dl/chat?[id]
          url: this.profile.wechat ? `weixin://dl/chat?${this.profile.wechat}` : null,
        },
      ]
    },
  },
  methods: {
    handleClickPhoneLink({ name, value }, event) {
      this.socialMediaName = name;
      this.phoneNumberForPopup = value;
      this.isShowPopup = true;
      event.preventDefault();
    },
    handleClickClosePopup() {
      this.isShowPopup = false;
    },
    getNumberWithoutPlus(number) {
      return number.slice(0, 1) === "+" ? number.substr(1) : number;
    },
    getNumberForViberDesktop(number) {
      const plus = "%2B";
      return number.slice(0, 1) === "+"
        ? number.replace("+", plus)
        : plus + number;
    },
  },
  data() {
    return {
      isShowPopup: false,
      socialMediaName: null,
      phoneNumberForPopup: null,
    };
  },
};
</script>

<style lang="scss" scoped>
.publicProfile {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__location {
    @media (min-width: $breakpoint-md) {
      margin-right: 32px;
    }
  }

  &__avatar {
    width: 144px;
    border-radius: 4px;

    @media (min-width: $breakpoint-md) {
      width: 172px;
    }
  }

  &__name {
    @include text-h5;
    color: #fff;

    margin-top: 24px;

    @media (min-width: $breakpoint-md) {
      font-size: 18px;
      margin-top: 32px;
    }
  }

  &__info {
    @include text-subtitle-2;
    text-align: center;
    font-size: 12px;
    line-height: 16px;
    color: #6999e9;
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media (min-width: $breakpoint-md) {
      flex-direction: row;
      font-size: 14px;
      line-height: 24px;
    }
  }

  &__description {
    @include text-body-2;
    color: #fff;
    font-weight: 400;
    margin-top: 32px;
    text-align: center;
    padding: 0;

    @media (min-width: $breakpoint-md) {
      margin-top: 30px;
      font-size: 16px;
      padding: 0 54px;
    }

    @media (min-width: $breakpoint-xl) {
      padding: 0 72px;
    }
  }
  &__btn {
    border: 2px solid #fff;
    padding: 21px 0;
    color: #fff;
    font-size: 16px;
    font-family: $font-secondary;
    min-width: 100%;
    font-weight: 400;
    border-radius: 6px;
    text-align: center;
    margin-top: 24px;

    @media (min-width: $breakpoint-md) {
      margin-top: 32px;
      min-width: 268px;
    }

    &:hover {
      color: #000000de;
      background-color: #fff;
    }
  }
}
.socialMedia {
  display: flex;
  width: 271px;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 24px;

  @media (min-width: $breakpoint-md) {
    width: 100%;
    margin-top: 40px;
  }

  &__item {
    padding: 0 16px;
  }
}

.popupContent {
  text-align: center;

  &__title {
    color: #00000061;
    font-size: 18px;
    line-height: 24px;
    font-family: $font-secondary;
    font-weight: 700;
  }

  &__text {
    font-size: 24px;
    line-height: 30px;
    font-family: $font-secondary;
    font-weight: 700;
    margin-top: 8;
    @media (min-width: $breakpoint-xl) {
      margin-top: 16px;
    }
  }
}

.icon {
  width: 16px;
  height: 16px;
  margin-right: 6px;

  @media (min-width: $breakpoint-md) {
    width: 24px;
    height: 24px;
  }
}
</style>
